import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import ComplaintsDetails from "../components/complaints/ComplaintsDetails";
import { useLoader } from "../context/LoaderContext";
import { useParams } from "react-router-dom";
import { dynamicFailed } from "../hooks/useToast";
import { IComplaint } from "../exports/interfaces";
import { fetchComplaints } from "../api/ComplaintApi";
import { useUser } from "../context/UserContext";

const ComplaintsDetailsPage = () => {
  const { id } = useParams();
  const { setLoading } = useLoader();

  const [complaint, setComplaint] = useState<IComplaint | null>(null);
  const [urgentCount, setUrgentCount] = useState<number>(0);
  const [notUrgentCount, setNotUrgentCount] = useState<number>(0);
  const [regularCount, setRegularCount] = useState<number>(0);
  const { user } = useUser();

  useEffect(() => {
    if (!user) {
      return;
    }
    Promise.all([fetchComplaints()])
      .then(([complaintData]) => {
        const foundComplaint = complaintData.find(
          (item: IComplaint) => item.id === Number(id),
        );
        const urgent = complaintData.filter(
          (n) => n.status === "Urgent",
        ).length;
        setUrgentCount(urgent);
        const notUrgent = complaintData.filter(
          (n) => n.status === "Not Urgent",
        ).length;
        setNotUrgentCount(notUrgent);
        const regular = complaintData.filter(
          (n) => n.status === "Regular",
        ).length;
        setRegularCount(regular);
        setComplaint(foundComplaint || null);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [id, setLoading, user]);
  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <ComplaintsDetails
          complaint={complaint}
          urgentCount={urgentCount}
          setUrgentCount={setRegularCount}
          notUrgentCount={notUrgentCount}
          setNotUrgentCount={setRegularCount}
          regularCount={regularCount}
          setRegularCount={setRegularCount}
        />
      </div>
    </PageLayout>
  );
};

export default ComplaintsDetailsPage;
